import BaseInput from 'Components/Form/BaseInput';
import { RegisterOptions } from 'react-hook-form';
import styles from './TextInput.module.css';
export interface TextInputProps extends ITextField {
  labelIcon?: React.ReactNode;
  rules?: RegisterOptions;
  disable?: boolean;
  autoComplete?: string;
  autoFocus?: boolean;
}
export const TextInput = ({
  name,
  type,
  placeholder = 'Enter...',
  rules,
  autoComplete = 'on',
  disable,
  autoFocus,
  ...rest
}: TextInputProps) => {
  return (
    <>
      <BaseInput name={name} {...rest}>
        {({ register }) => (
          <>
            <input
              {...register(name, rules)}
              autoFocus={autoFocus}
              className={`form__input`}
              type={type}
              placeholder={placeholder}
              disabled={disable}
              autoComplete={autoComplete}
            />
          </>
        )}
      </BaseInput>
    </>
  );
};
